import { resolveBundledClub } from './leagueClubs';

const polonia = resolveBundledClub('Polonia Glasgow AFC');

if (!polonia) {
  throw new Error('Bundled Polonia Glasgow AFC identity is missing.');
}

export const POLONIA_CLUB = polonia;
export const POLONIA_CREST = polonia.logo;
export const POLONIA_NAME = polonia.displayName;
